import { Entitlements } from '@experiences/constants';
import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useEntitlements } from '../../component/entitlements/EntitlementsContextProvider';
import { isAdminSelector } from '../../store/selectors';

/**
 * Detects whether the current org/user is a Test Cloud org.
 *
 * Test Cloud is identified by entitlements, NOT the license plan: the `TEST-TRIAL`
 * license only covers self-serve trials, whereas paid Test Cloud SKUs (Standard/Enterprise
 * Test Add-On) carry the `TestCloud.*` entitlements instead. When the
 * EnableTestCloudOrganizationAndUserEntitlements flag is off, fall back to the named-user
 * entitlements so detection still works in scale units where the flag is not enabled.
 */
const useIsTestCloud = () => {
    const { hasEntitlement } = useEntitlements();
    const isAdmin = useSelector(isAdminSelector);

    const EnableTestCloudOrganizationAndUserEntitlements = useFeatureFlagValue(Features.EnableTestCloudOrganizationAndUserEntitlements.name);

    return useMemo(() => {
        if (EnableTestCloudOrganizationAndUserEntitlements) {
            return isAdmin
                ? hasEntitlement(Entitlements.EligibleForOrganizationExperience)
                : hasEntitlement(Entitlements.EligibleForUserExperience);
        }
        return hasEntitlement(Entitlements.AppTester) || hasEntitlement(Entitlements.AppTestDeveloper);
    }, [ EnableTestCloudOrganizationAndUserEntitlements, hasEntitlement, isAdmin ]);
};

export default useIsTestCloud;
